// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

function InputText({ inputRef, ...props }) {
  return (
    tag('input', {
      ref: inputRef,
      ...props
    })
  )
}

InputText.defaultProps = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: 'false',
  type: 'text'
}

if (__DEV__) {
  // Prop-checking imports
  const morePropTypes = require('client-v2/common/utils/prop-types')

  InputText.propTypes = {
    inputRef: morePropTypes.domRef
  }
}

module.exports = InputText
